import { useEffect, useRef, useState } from "react";
import { createLeadIdAPI, generateJWTTokenLintraAPI } from "../../services/lentraService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {  handleShowContextualLoader } from "../../utils/contextualLoaderTrigger";
import { getPhoneNo } from "../../utils/storage";

export default function LentraJourney() {
  
  const [iframeUrl, setIframeUrl] = useState("");

  const iframeRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    initJourney();
  }, []);

  const initJourney = async () => {
    if (!getPhoneNo) return;

    try {
      const jwtRes = await generateJWTTokenLintraAPI();

      const token = jwtRes?.oBody?.payLoad?.token;
      localStorage.setItem("lentra_jwt_token", token);

      if (token) {
        await generateLead(getPhoneNo);
      } else {
        console.log("JWT token failed!");
      }
    } catch (error) {
      console.log("Init error:", error);
      navigate("/lentra-error");
    } 
  };

  const generateLead = async (getPhoneNo) => {
    const token = localStorage.getItem("lentra_jwt_token");

    try {
      const res = await createLeadIdAPI();
      // setIframeUrl(res.journey_app_url);

      const url = res?.journey_app_url;

      console.log("url--------", url);

      const params = new URL(url).searchParams.get("z");

      console.log("params-------", params);

      const decodeParams = decodeURIComponent(params);

      console.log("decodeParams------------", decodeParams);

      const queryParams = atob(decodeParams);

      console.log("queryParams------------", queryParams);

      const finalParams = `${queryParams}&ott=${token}`;

      console.log("finalParams-----------", finalParams);

      const encodedParams = encodeURIComponent(btoa(finalParams));

      const baseUrl = url.split("?")[0];

      const finalBaseUrl = `${baseUrl}?z=${encodedParams}`;

      if (window.parent) {
        window.parent.location.href = finalBaseUrl;
      } else {
        window.location.href = finalBaseUrl;
      }
    } catch (error) {
      console.log(error);
      navigate("/lentra-error");
    }
  };

  useEffect(() => {
    if (!iframeUrl) return;

    const iframe = iframeRef.current;
    if (!iframe) return;

    console.log("Parent loaded. Waiting for child...");

    //  Listen ONCE, globally
    window.addEventListener("message", function (event) {
      console.log("📩 PARENT RECEIVED:", event.origin, event.data);

      if (event.data && event.data.type === "APP_INITIATED") {
        console.log("APP_INITIATED received from child");

        const response = {
          type: "JWT_TOKEN",
          payload: {
            token: localStorage.getItem("lentra_jwt_token"),
          },
        };

        // ALWAYS reply using iframe reference
        iframe.contentWindow.postMessage(response, event.origin);

        console.log("✅ JWT_TOKEN sent to child");
      }
    });

    // iframe.addEventListener("load", handleLoad);

    // return () => {
    //   iframe.removeEventListener("load", handleLoad);
    // };
  }, [iframeUrl]);

  // window.addEventListener('message', this.onMessage);

  console.log("iframeUrl------------", iframeUrl);

  // const urls = "https://7104365894002.serviceurl.in/portal/?instId=9425&envId=1085&product=HL&appType=INDEPENDENT&tag=Test";

  return (
<div>{handleShowContextualLoader("Please wait...")}</div>

  );
}
